export default {
    /**
     * Strip the markup nodes from a given string
     *
     * @param {string} text
     * @returns {string}
     */
    stripMarkup(text) {
        return text.replace(/(<([^>]+)>)/ig, '');
    },

    /**
     * Lowercase the string
     */
    lowercase(text) {
        return text.toLowerCase();
    },
};

